// extracted by mini-css-extract-plugin
module.exports = {"announcementWrapper":"PrivateChatBasicAnnouncement__announcementWrapper__2oX12","link":"PrivateChatBasicAnnouncement__link__1cbpw"};